import { Button, Dialog, Text } from 'braid-design-system';

interface LoginPromptProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  login: (returnTo: string) => void;
  redirect: string;
}

export const LoginPrompt = ({
  open,
  setOpen,
  login,
  redirect,
}: LoginPromptProps) => (
  <Dialog
    width="xsmall"
    id="login-dialog"
    title="Login"
    open={open}
    onClose={() => setOpen(false)}
  >
    <Text>
      It appears you are not logged in. Log in to pre-fill some details.
    </Text>
    <Button
      onClick={() => {
        login(redirect);
        setOpen(false);
      }}
      tone="formAccent"
    >
      Login
    </Button>
  </Dialog>
);
